import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Setting, SettingsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class SettingsDataService {

  private uri: string = `${environment.apiUrl}settings`;
  private cacheKey: string = 'settings.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getSetting(id: number): Observable<Setting|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSettings(parameters: {[param: string]: string | string[]}): Observable<SettingsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addSetting(data: Setting): Observable<Setting|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addSettings(data: Setting[]): Observable<Setting[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateSetting(data: Setting): Observable<Setting|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSettings(data: Setting[]): Observable<Setting[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchSetting(data: Setting): Observable<Setting|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSettings(data: Setting[]): Observable<Setting[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteSetting(data: Setting): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSettings(data: Setting[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((setting) => {
      ids.push(setting.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
